import React from "react";

import { formatBytes } from "utils/utils";
import { appInsightsTracker } from "utils/AppInsightsManager/appInsights.utils";
import { useRedirectIfUnauthenticated } from "utils/azureAD/useRedirectIfUnauthenticated";

export const WithTraceLogger : React.FunctionComponent<{children: React.ReactNode}> = ({children, }) => {
  const { accounts } = useRedirectIfUnauthenticated();

  if (!navigator.onLine) {
    return <>{children}</>;
  }
 const username = accounts[0]?.username
 
  const onMessage = ({ data }: any) => {
    //got a message from the service worker
    console.info(`${username} saved ${formatBytes(data?.bufferSize, 4)} in indexedDB`);
    appInsightsTracker.trackTrace(`${username} saved ${formatBytes(data?.bufferSize, 4)} in indexedDB`)
  };

  navigator.serviceWorker.addEventListener("message", onMessage);

  return <>{children}</>;
};
